module.exports = __webpack_public_path__ + "static/media/main_ourservices.e72e0178.png";